import React, { useState, useEffect } from 'react';
import { Play, Calendar } from 'lucide-react';

const HeroSection = ({ onWatchProof, onBookCall }) => {
  const [useVideo, setUseVideo] = useState(true);
  const videoUrl = 'https://customer-assets.emergentagent.com/job_foxpress-creative/artifacts/0pm2llmc_Video.mp4';
  
  useEffect(() => {
    if (videoUrl) setUseVideo(true);
  }, []);
  
  return (
    <section className="min-h-screen flex items-center justify-center bg-[#040c14] text-white px-4 py-20 relative overflow-hidden">
      {/* Video Background (Hidden until you add video URL) */}
      {useVideo && videoUrl ? (
        <div className="absolute inset-0 z-0">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="paramount-video-bg"
          >
            <source src={videoUrl} type="video/mp4" />
          </video>
          {/* Lighter overlay - let video show through more */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-[#040c14]/70"></div>
          {/* Subtle vignette for text focus */}
          <div className="absolute inset-0 bg-radial-gradient-light"></div>
        </div>
      ) : (
        /* Paramount-Style: Cinematic Parallax Background */
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {/* Large cinematic film-like gradient sweep */}
          <div className="paramount-sweep paramount-sweep-1"></div>
          <div className="paramount-sweep paramount-sweep-2"></div>
          <div className="paramount-sweep paramount-sweep-3"></div>
          
          {/* Subtle light rays - like film projector */}
          <div className="film-ray film-ray-1"></div>
          <div className="film-ray film-ray-2"></div>
          <div className="film-ray film-ray-3"></div>
          
          {/* Atmospheric particles - dust in projector light */}
          <div className="film-dust film-dust-1"></div>
          <div className="film-dust film-dust-2"></div>
          <div className="film-dust film-dust-3"></div>
          <div className="film-dust film-dust-4"></div>
          <div className="film-dust film-dust-5"></div>
          <div className="film-dust film-dust-6"></div>
          <div className="film-dust film-dust-7"></div>
          <div className="film-dust film-dust-8"></div>
          
          {/* Vignette effect - Paramount signature */}
          <div className="paramount-vignette"></div>
          
          {/* Dark overlay for text readability */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-[#040c14]/90"></div>
        </div>
      )}
      
      <div className="max-w-6xl w-full relative z-10">
        <div className="text-center space-y-8">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold leading-tight tracking-tight drop-shadow-2xl hero-text" style={{ textShadow: '0 4px 20px rgba(0, 0, 0, 0.9), 0 2px 8px rgba(0, 0, 0, 0.8)' }}>
            Professional book trailers and visual development materials <span className="text-[#FF6500]">for authors.</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-[#aaa] max-w-4xl mx-auto leading-relaxed drop-shadow-lg" style={{ textShadow: '0 2px 12px rgba(0, 0, 0, 0.9)' }}>
            Cinematic assets that power your book marketing and open the door to adaptation conversations.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8">
            <div className="flex flex-col items-center">
              <button
                onClick={onWatchProof}
                className="group px-8 py-4 bg-[#FF6500] hover:bg-[#E65A00] text-black font-medium rounded-full transition-all duration-300 flex items-center gap-3 text-base uppercase tracking-wider shadow-lg shadow-[#FF6500]/20 hover:shadow-[#FF6500]/40 hover:scale-105"
              >
                <Play className="w-5 h-5 group-hover:scale-110 transition-transform" />
                See How It Works
              </button>
            </div>
            
            <div className="flex flex-col items-center">
              <button
                onClick={onBookCall}
                className="px-8 py-4 bg-transparent hover:bg-white/10 text-white border-2 border-white/20 hover:border-white/40 font-medium rounded-full transition-all duration-300 flex items-center gap-3 text-base uppercase tracking-wider hover:scale-105"
              >
                <Calendar className="w-5 h-5" />
                Book Your Consultation
              </button>
              <p className="text-xs text-[#666] mt-2">Free 20-minute call, no commitment</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Instructions comment for adding video later */}
      {/* 
        TO ADD YOUR VIDEO:
        1. Upload your video to /app/backend/uploads/videos/ or use external URL
        2. Update the videoUrl variable at the top of this component
        3. Uncomment the useEffect hook
        4. Supported formats: MP4, WebM, OGG
        5. Recommended: Keep video under 50MB for fast loading
      */}
    </section>
  );
};

export default HeroSection;